module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-TWITTER.cd967642.png";